var map = {
	"./Electrocoin.png": 3352,
	"./GD.png": 1879,
	"./GEMPAD.png": 8965,
	"./HOTKEY.png": 7034,
	"./Lodestar.png": 9616,
	"./SOLIDproof.png": 7236,
	"./Uprising.png": 4843,
	"./infinity.png": 3714
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5686;